import { useI18n } from '@/i18n'
import { MagnifyingGlass, X } from '@/shared/icons/phosphor'
import { type JSX, Show, splitProps } from 'solid-js'

export interface SearchFieldProps
  extends Omit<JSX.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size' | 'value' | 'onInput'> {
  value: string
  onInput: (value: string) => void
  class?: string
}

export function SearchField(props: SearchFieldProps) {
  const { t } = useI18n()
  const [local, rest] = splitProps(props, ['value', 'onInput', 'class', 'placeholder'])

  return (
    <div class={`relative ${local.class ?? ''}`}>
      <input
        {...rest}
        type="text"
        aria-label={rest['aria-label'] ?? local.placeholder ?? t('shared.searchBar.placeholder')}
        value={local.value}
        onInput={(e) => local.onInput(e.currentTarget.value)}
        placeholder={local.placeholder ?? t('shared.searchBar.placeholder')}
        class={
          'ds-field w-full h-10 pl-3.5 pr-10 rounded-[var(--radius-12)] bg-[var(--color-surface)] border border-[var(--color-border)] hover:border-[var(--color-neutral-300)] text-[length:var(--text-sm)] text-[color:var(--color-text)] placeholder:text-[color:var(--color-text-muted)] outline-none transition-[border-color,box-shadow] duration-[var(--duration-fast)] focus:border-[var(--color-primary-400)] focus:shadow-[var(--focus-ring)]'
        }
      />
      <Show
        when={local.value}
        fallback={
          <MagnifyingGlass
            class={
              'pointer-events-none absolute right-3 w-[17px] h-[17px] top-1/2 -translate-y-1/2 text-[color:var(--color-text-muted)]'
            }
            aria-hidden="true"
          />
        }
      >
        <button
          type="button"
          onClick={() => local.onInput('')}
          aria-label={t('shared.searchBar.clear')}
          class="absolute right-1 top-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-[var(--radius-8)] text-[color:var(--color-text-muted)] hover:text-[color:var(--color-text)] focus-visible:outline-2 focus-visible:outline-[var(--color-primary-500)] transition-colors cursor-pointer"
        >
          <X class="h-4 w-4" aria-hidden="true" />
        </button>
      </Show>
    </div>
  )
}
